import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder, Validators, AbstractControl, ValidationErrors } from '@angular/forms';

import { SocialSigninService } from '../../social-signin/social-signin.service';

function passwordsMatchValidator(group: AbstractControl): ValidationErrors | null {
    const password = group.get('password')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { passwordMismatch: true };
}

@Component({
    standalone: false,
    selector: 'abs-registration',
    template: `
        <abs-page-layout [pageTitle]="'GLOBAL.LOGIN.REGISTER.TITLE' | translate">
            <form [formGroup]="registrationForm" (ngSubmit)="register()" class="content">
                <div class="form-row">
                    <ion-label>{{ 'GLOBAL.LOGIN.EMAIL' | translate }}</ion-label>
                    <ion-input type="email" formControlName="email"></ion-input>
                </div>
                <div class="form-row">
                    <ion-label>{{ 'GLOBAL.LOGIN.PASSWORD' | translate }}</ion-label>
                    <ion-input type="password" formControlName="password"></ion-input>
                </div>
                <div class="form-row">
                    <ion-label>{{ 'GLOBAL.LOGIN.REGISTER.CONFIRM_PASSWORD' | translate }}</ion-label>
                    <ion-input type="password" formControlName="confirmPassword"></ion-input>
                </div>
                <p class="error" *ngIf="error">{{ 'GLOBAL.ERRORS.' + error | translate }}</p>
                <div class="buttons">
                    <ion-button type="submit" [disabled]="registrationForm.invalid || submitting">
                        {{ 'GLOBAL.LOGIN.REGISTER.SUBMIT' | translate }}
                        <ion-spinner name="crescent" *ngIf="submitting"></ion-spinner>
                    </ion-button>
                </div>

                <p class="loginPrompt">
                    {{ 'GLOBAL.LOGIN.REGISTER.LOGIN_PROMPT' | translate }}
                    <a [routerLink]="'/login'">{{ 'GLOBAL.LOGIN.BUTTONS.LOGIN' | translate }}</a>
                </p>
            </form>
        </abs-page-layout>
    `,
    styles: [
        `
            .loginPrompt {
                text-align: center;
                margin-top: 16px;
            }
        `
    ]
})
export class RegistrationPage {
    submitting = false;
    error: string = null;

    registrationForm = this.fb.group(
        {
            email: this.fb.control('', [Validators.required, Validators.email]),
            password: this.fb.control('', [Validators.required, Validators.minLength(8)]),
            confirmPassword: this.fb.control('', [Validators.required])
        },
        { validators: passwordsMatchValidator }
    );

    constructor(
        private fb: UntypedFormBuilder,
        private socialSignin: SocialSigninService,
        private router: Router
    ) {}

    async register() {
        if (this.registrationForm.invalid) {
            return;
        }

        this.error = null;
        this.submitting = true;

        const { email, password } = this.registrationForm.value;

        try {
            const credential = await this.socialSignin.registerWithEmail(email, password);
            await this.socialSignin.sendVerificationEmail(credential.user);
            this.router.navigate(['/verify-email']);
        } catch (err: any) {
            this.error = err.code || 'UNKNOWN';
        } finally {
            this.submitting = false;
        }
    }
}
